export function ConversionArchitecture() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Conversion Architecture
            </h2>
            <div className="w-24 h-1 bg-teal-500 mb-8"></div>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Your website isn't just a digital brochure—it's a 24/7 sales system designed to turn visitors into customers.
            </p>

            <div className="space-y-6">
              {[
                {
                  icon: 'ri-cursor-line',
                  title: 'Strategic Call-to-Action Placement',
                  desc: 'Buttons and forms positioned exactly where visitors are ready to take action'
                },
                {
                  icon: 'ri-user-add-line',
                  title: 'Lead Capture Optimization',
                  desc: 'Forms designed to maximize submissions without creating friction'
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'Trust-Building Sections',
                  desc: 'Social proof, testimonials, and credentials that establish credibility'
                },
                {
                  icon: 'ri-file-list-3-line',
                  title: 'Strong Service Explanations',
                  desc: 'Clear, compelling descriptions that answer customer questions'
                },
                {
                  icon: 'ri-smartphone-line',
                  title: 'Mobile-First UX',
                  desc: 'Seamless experience across all devices where customers browse'
                }
              ].map((feature, index) => (
                <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-5 shadow-md hover:shadow-lg transition-all border border-gray-100">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
              <div className="space-y-6">
                {/* Conversion Funnel Visual */}
                <div className="text-center">
                  <div className="inline-block bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl px-6 py-4 mb-4 w-full">
                    <div className="flex items-center justify-between">
                      <span className="font-bold">Website Visitors</span>
                      <span className="text-2xl font-bold">1,000</span>
                    </div>
                  </div>
                  <div className="flex justify-center mb-4">
                    <i className="ri-arrow-down-line text-teal-500 text-3xl"></i>
                  </div>
                  <div className="inline-block bg-gradient-to-br from-purple-500 to-purple-600 text-white rounded-xl px-6 py-4 mb-4 w-4/5">
                    <div className="flex items-center justify-between">
                      <span className="font-bold">Engaged Users</span>
                      <span className="text-2xl font-bold">450</span>
                    </div>
                  </div>
                  <div className="flex justify-center mb-4">
                    <i className="ri-arrow-down-line text-teal-500 text-3xl"></i>
                  </div>
                  <div className="inline-block bg-gradient-to-br from-teal-500 to-cyan-500 text-white rounded-xl px-6 py-4 mb-4 w-3/5">
                    <div className="flex items-center justify-between">
                      <span className="font-bold">Form Views</span>
                      <span className="text-2xl font-bold">180</span>
                    </div>
                  </div>
                  <div className="flex justify-center mb-4">
                    <i className="ri-arrow-down-line text-teal-500 text-3xl"></i>
                  </div>
                  <div className="inline-block bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-xl px-6 py-4 w-2/5">
                    <div className="flex items-center justify-between">
                      <span className="font-bold">Leads</span>
                      <span className="text-2xl font-bold">72</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-xl p-6 text-white text-center">
                  <p className="text-3xl font-bold mb-2">7.2%</p>
                  <p className="text-sm font-medium">Conversion Rate</p>
                  <p className="text-xs mt-2 opacity-90">Industry average: 2-3%</p>
                </div>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -top-6 -right-6 bg-white rounded-xl shadow-xl p-4 border-2 border-teal-500">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-trophy-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-600">24/7 Sales System</p>
                  <p className="text-lg font-bold text-gray-900">Always Working</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}